import React from 'react';
import ShopCatalog from './ShopCatalog';

export default function ShopParts() {
    return <ShopCatalog productType="part" key="part" />;
}